// @generated by TypeGen from LogbookApp/AlertApi.swift - DO NOT EDIT

import { IShipUserLevel } from "../LogbookModel/ShipUser"
import type { IAlertLoudness } from "../LogbookModel/Status/AlertEngineModel"
import type { IAlertStatus } from "../LogbookModel/Status/AlertStatus"
import type { IAppResponse } from "./Routes"

export interface IAlertCommandRequest {
  action: IAlertCommandAction;
  minutes?: number;
  episodeId?: string;
}

export interface IAlertMessageRequest {
  users: number[];
  groups: string[];
  message: string;
  severity: IAlertStatus;
  loudness: IAlertLoudness;
}

export interface IAlertReceiptRequest {
  dayId: number;
  statusId: number;
}

export enum IAlertCommandAction {
  snooze = "snooze",
  acknowledge = "acknowledge",
  clear = "clear",
  escalate = "escalate",
}

export interface AlertApiAppEndpoints {
  "POST /api/ship/alert/manOverboard": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/alert/message": {
    params: {};
    query: {};
    request: IAlertMessageRequest;
    response: IAppResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/alert/receipt/:alertName": {
    params: { alertName: string };
    query: {};
    request: IAlertReceiptRequest;
    response: IAppResponse;
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ship/alert/:alertName": {
    params: { alertName: string };
    query: {};
    request: IAlertCommandRequest;
    response: IAppResponse;
    permission: { ship: IShipUserLevel };
  };
}

export const alertApiAppEndpoints = {
  "POST /api/ship/alert/manOverboard": { permission: { ship: IShipUserLevel.viewCurrent } },
  "POST /api/ship/alert/message": { permission: { ship: IShipUserLevel.viewCurrent } },
  "POST /api/ship/alert/receipt/:alertName": { permission: { ship: IShipUserLevel.viewCurrent } },
  "PUT /api/ship/alert/:alertName": { permission: { ship: IShipUserLevel.viewCurrent } },
} as const;
